import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ApplicationStore, ApplicationStoreType } from '../../../../core/store/application.store';
import { PopupBaseComponent } from '../popup-base/popup-base.component';
import { ButtonComponent, ButtonType } from '../../button/button.component';
import { ConfirmationPopupModel } from './confirmation-popup.model';

@Component({
    selector: 'juyo-confirmation-popup',
    styleUrl: 'confirmation-popup.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PopupBaseComponent, ButtonComponent],
    template: `
        <juyo-popup-base [popupId]="model().id" [showHeader]="true">
            <span slot="header">{{ model().title }}</span>

            <p slot="body" class="content">{{ model().content }}</p>

            <ng-container slot="footer">
                <juyo-button
                    [buttonType]="ButtonType.TRANSPARENT"
                    (clicked)="onCancel()"
                >
                    Cancel
                </juyo-button>
                <juyo-button
                    [buttonType]="ButtonType.PURPLE"
                    (clicked)="onConfirm()"
                >
                    Confirm
                </juyo-button>
            </ng-container>
        </juyo-popup-base>
    `,
})
export class ConfirmationPopupComponent {
    public model = input.required<ConfirmationPopupModel>();

    protected readonly ButtonType = ButtonType;

    private applicationStore: ApplicationStoreType = inject(ApplicationStore);

    protected onConfirm(): void {
        const model = this.model();

        model.onConfirm();
        this.applicationStore.closePopup(model.id);
    }

    protected onCancel(): void {
        const model = this.model();

        model.onCancel();
        this.applicationStore.closePopup(model.id);
    }
}
